import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux-immutable';
import {
  createAsyncReducer,
  initialAsyncState,
  toSuccess,
} from '../utils/asyncHelpers';
import {
  ENTITY_DOCUMENT_ADD,
  ENTITY_DOCUMENT_DELETE,
  ENTITY_DOCUMENT_FETCH,
  ENTITY_DOCUMENT_ACTIVATE,
  ENTITY_DOCUMENT_DEACTIVATE,
} from '../constants/registerActionTypes';

const list = handleActions(
  {
    ...createAsyncReducer(ENTITY_DOCUMENT_FETCH),
    [toSuccess(ENTITY_DOCUMENT_ADD)]: (state, { payload }) =>
      state.set('data', state.get('data').concat(payload.result)),
    [toSuccess(ENTITY_DOCUMENT_DELETE)]: (state, { payload }) =>
      state.set(
        'data',
        state.get('data').filter((id) => id !== payload)
      ),
  },
  initialAsyncState
);

const statusChange = handleActions(
  {
    ...createAsyncReducer(ENTITY_DOCUMENT_ACTIVATE),
    ...createAsyncReducer(ENTITY_DOCUMENT_DEACTIVATE),
  },
  initialAsyncState
);

const registerEntityDocumentsReducer = combineReducers({
  list,
  add: handleActions(
    createAsyncReducer(ENTITY_DOCUMENT_ADD),
    initialAsyncState
  ),
  delete: handleActions(
    createAsyncReducer(ENTITY_DOCUMENT_DELETE),
    initialAsyncState
  ),
  statusChange,
});

export const getEntityDocumentsList = (state) =>
  state.getIn(['registerEntityDocuments', 'list']);

export const getEntityDocumentsAddState = (state) =>
  state.getIn(['registerEntityDocuments', 'add']);

export const getEntityDocumentsDeleteState = (state) =>
  state.getIn(['registerEntityDocuments', 'delete']);

export const getEntityDocumentsStatusChangeState = (state) =>
  state.getIn(['registerEntityDocuments', 'statusChange']);

export default registerEntityDocumentsReducer;
